export default () => {
  const linkButton = document.querySelectorAll(".js-link-button");
  const popupStore = document.querySelector(".js-popup-store");
  const popupStoreClose = popupStore.querySelector(".js-store-close");
  const popupBlocks = popupStore.querySelectorAll('[data-block]');
  const btnMap = document.querySelector(".js-store-btn-map");
  const btnList = document.querySelector(".js-store-btn-list");
  const storeList = document.querySelector(".js-store-list");
  const mapEl = document.querySelector(".js-map-store");
  const storeDescription = document.querySelector(".js-store-description");

  if (linkButton.length) {
    linkButton.forEach(oBtn => {
      oBtn.addEventListener("click", () => {
        popupStore.style.display = "block";
      });
    });
  }

  btnMap.addEventListener("click", () => {
    btnList.classList.remove("active");
    btnMap.classList.add("active");

    storeList.style.display = "none";
    mapEl.style.display = "block";
    storeDescription.style.display = "none";
  });

  btnList.addEventListener("click", () => {
    btnMap.classList.remove("active");
    btnList.classList.add("active");

    mapEl.style.display = "none";
    storeList.style.display = "block";
    storeDescription.style.display = "block";
  });

  window.addEventListener("resize", () => {
    if (window.innerWidth > 767) {
      storeList.style.display = "block";
      mapEl.style.display = "block";
      storeDescription.style.display = "block";
    }
  });

  popupStoreClose.addEventListener('click', () => {
    popupStore.style.display = "none";

    popupBlocks.forEach(oNode => oNode.style = '');
  });

  popupStore.addEventListener('click', ({ target }) => {
    if (!(target.closest(`.js-popup-store-body`) || target.nodeName.toLowerCase() === 'ymaps')) {
      popupStore.style.display = "none";
      popupBlocks.forEach(oNode => oNode.style = '');
    }
  });
};
